import { render, staticRenderFns } from "./user-management.vue?vue&type=template&id=61cbe57c&"
import script from "./user-management.vue?vue&type=script&lang=ts&"
export * from "./user-management.vue?vue&type=script&lang=ts&"
import style0 from "./user-management.vue?vue&type=style&index=0&id=61cbe57c&prod&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports